import script from "./ProductDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetails.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetails.vue?vue&type=style&index=0&id=3799dbd1&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3799dbd1"]])

export default __exports__